if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    connectedCallback() {
      this.slider = this.querySelector(`#product-slider__slider-${this.sectionId}`);
      this.leftArrow = this.querySelector(`#product-slider__left-arrow-${this.sectionId}`);
      this.rightArrow = this.querySelector(`#product-slider__right-arrow-${this.sectionId}`);

      this.maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
      // set default arrow visibility
      if (this.slider.scrollLeft === 0) {
        this.leftArrow.dataset.visibility = 'hidden';
        this.rightArrow.dataset.visibility = 'show';
      } else if (this.slider.scrollLeft >= this.maxScrollLeft - 1) {
        this.rightArrow.dataset.visibility = 'hidden';
        this.leftArrow.dataset.visibility = 'show';
      }


      this.handleScroll = this.handleScroll.bind(this);

      this.slider.addEventListener('scroll', this.handleScroll);
      this.leftArrow.addEventListener('click', this.handleScroll);
      this.rightArrow.addEventListener('click', this.handleScroll);
    }

    disconnectedCallback() {
      this.slider.removeEventListener('scroll', this.handleScroll);
      this.leftArrow.removeEventListener('click', this.handleScroll);
      this.rightArrow.removeEventListener('click', this.handleScroll);
    }

    handleScroll(e) {
      // scroll the slider if one of the arrow is clicked
      if (e.type === 'click') {
        const isLeft = e.target === this.leftArrow || this.leftArrow.contains(e.target);
        const isRight = e.target === this.rightArrow || this.rightArrow.contains(e.target);

        if (isLeft) {
          const currentLeft = this.slider.scrollLeft;
          const targetLeft = Math.max(0, currentLeft - this.slider.clientWidth);
          this.slider.scroll({ left: targetLeft, behavior: 'smooth' });
        } else if (isRight) {
          const currentLeft = this.slider.scrollLeft;
          const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
          const targetLeft = Math.min(maxScroll, currentLeft + this.slider.clientWidth);
          this.slider.scroll({ left: targetLeft, behavior: 'smooth' });
        }
      }

      // hide the arrows based on slider scrollLeft and maxScrollLeft
      // triggered for mouse scroll or arrow clicks
      if (this.slider.scrollLeft === 0) {
        this.leftArrow.dataset.visibility = 'hidden';
        this.rightArrow.dataset.visibility = 'show';
      } else if (this.slider.scrollLeft >= this.maxScrollLeft - 1) {
        this.rightArrow.dataset.visibility = 'hidden';
        this.leftArrow.dataset.visibility = 'show';
      } else {
        this.rightArrow.dataset.visibility = 'show';
        this.leftArrow.dataset.visibility = 'show';
      }
    }
  }

  customElements.define('product-slider', ProductSlider);
}
